import { Component, Input, ContentChildren, QueryList } from "@angular/core";
import { DsOptionComponent } from "../ds-option/ds-option.component";

@Component({
  selector: "ds-option-group",
  templateUrl: "./ds-option-group.component.html",
  styleUrls: ["./ds-option-group.component.scss"],
})
export class DsOptionGroupComponent {
  @Input() label: string = "";
  @ContentChildren(DsOptionComponent, { descendants: true }) options!: QueryList<DsOptionComponent>;

  hidden = false;

  constructor() {}

  checkVisibility(): void {
    if (!this.options || this.options.length === 0) {
      this.hidden = true;
      return;
    }
    this.hidden = this.options.toArray().every((opt) => opt.hidden);
  }
}
